<div class="card">
  <ng-container *ngIf="status == 'OK'">
    <div class="avatar-title bg-light text-primary display-5 rounded-circle">
      <i class="uil uil-thumbs-up"></i>
      {{ status }}
    </div>
  </ng-container>
  <ng-container *ngIf="status == 'NOK'">
    <div class="avatar-title bg-light text-danger display-5 rounded-circle">
      <i class="uil uil-thumbs-down"></i>
      {{ status }}
    </div>
  </ng-container>
</div>
